import PubSub from 'pubsub-js';
import { TOPIC_IDS } from '@/js/constants';

export class MenuLinkHandler {
  private menuElement: HTMLElement | null;
  private togglerElements: HTMLElement[];

  constructor(private menuSelector: string) {
    this.menuElement = document.querySelector(this.menuSelector) as HTMLElement;
    this.togglerElements = [];
    this.initialize();
  }

  private initialize() {
    if (!this.menuElement) return;
    if (!this.menuElement.classList.contains('js-menu--foundation')) return;

    // トグラー要素を取得（Menu クラスと同様）
    this.togglerElements = [...document.querySelectorAll(`${this.menuSelector}-toggler`)] as HTMLElement[];

    // メニュー内のリンクにイベントリスナーを追加
    const links = this.menuElement.querySelectorAll('a');
    links.forEach((link) => {
      link.addEventListener('click', this.handleLinkClick.bind(this));
    });
  }

  private handleLinkClick(event: MouseEvent) {
    const link = event.currentTarget as HTMLAnchorElement;
    const href = link.getAttribute('href');

    // ページ内リンクの場合は即座にスクロール制御解除
    if (href?.startsWith('#')) {
      PubSub.publish(TOPIC_IDS.DISABLE_SCROLL_RELEASE);
    }

    if (this.togglerElements.length > 0 && this.menuElement?.classList.contains('is-expanded')) {
      // 非同期でトグラーのクリックを実行して、ナビゲーションとの競合を避ける
      setTimeout(() => {
        this.togglerElements[0].click();
      }, 0);
    }
  }
}
